export interface Document {
	id: string;
	name: string;
	document_url: string;
	url?: string;
	category: DocumentCategory;
	/** API may return null for documents uploaded before language was required */
	language?: DocumentLanguage | null;
	created_at: string;
	starts_at?: string | null;
	expires_at?: string | null;
	/** API may return null when no groups are assigned */
	groups: string[] | null;
}
export interface CreateDocument {
	name: string;
	category: DocumentCategory;
	groupIds: string[];
	file: File;
}
export const DOCUMENT_CATEGORIES = ["Terms", "Brochure", "Form"] as const;

export type DocumentCategory = (typeof DOCUMENT_CATEGORIES)[number];

export const DOCUMENT_LANGUAGES = ["nb-NO", "en"] as const;

export type DocumentLanguage = (typeof DOCUMENT_LANGUAGES)[number];

/** Select sentinel for clearing language. Sent to the API as `null`. */
export const UNSET_DOCUMENT_LANGUAGE = "unset";
